"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
let BindIpByVdDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.row = {};
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.remark = "";
  }
  open(row) {
    return __async(this, null, function* () {
      this.row = row;
      if (row.remark) {
        this.remark = row.remark;
      }
      this.dialog.visible = true;
    });
  }
  cancel() {
    return __async(this, null, function* () {
      this.close();
    });
  }
  editRemark() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth.pro/v1/shops/${this.row.id}`, {
          "model": "shop.remark.edit",
          "remark": this.remark
        });
        this.$message.success(this.$t("edit_remark_dialog.edit_remark_success"));
        this.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this.dialog.visible = false;
    this.remark = "";
    this.row = null;
  }
};
BindIpByVdDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], BindIpByVdDialog);
export {
  BindIpByVdDialog as default
};
